export default function Bagis() {
    return (
        <>
            <div className="container">
                <div class="card my-5 text-center">
                    <div class="card-header">
                        <h3>Bağışlarınız bizim için değerlidir.</h3>
                    
                </div>
                <div class="card-body">
                    <h5 class="card-title">Sistemin devamlılığı için bağışlarınıza ihtiyacımız var. Arka planda kullanılan programların lisans bedelleri için rapor başına 50 TL gibi küçük bir bağış talep ediyoruz. Sistemi beğendiyseniz lütfen katkılarınızı esirgemeyiniz.</h5>
                    <p class="card-text mt-5 fs-3 fw-bold">Mutlu Kızılçay</p>
                    <p class="card-text mt-5 fs-5 fw-bold">IBAN NO: TR780001000873310926475001</p>
                    <p class="card-text mt-5 fs-3 fw-bold">Açıklama: *Kullanıcı Adınız*</p>
                </div>
                <div class="card-footer">
                    Anlayışınız İçin Teşekkürler
                </div>
            </div>
        </div>
            
        </>
        
    )
}
